import{stringifyScope as e}from"@nohara-dxdev/roles";const t=async(t,n)=>{await t.delete(`/roles/scope`,{params:{scope:e(n)}})};export{t as deleteScopeRoles};
//# sourceMappingURL=delete-scope-roles.mjs.map